import CheckboxGroupBuilder from './CheckboxGroupBuilder';
import CheckboxFilterBuilder from './CheckboxFilterBuilder';

export default class DesktopCheckBoxGroup extends CheckboxGroupBuilder {
  /**
   * @inheritDoc
   */
  build(): HTMLElement {
    const filters = document.body.getElementByRef('filters');
    const expandedFilters = filters.getElementsByClassName('expanded');

    const groupHeaderTitle = this.group.getElementByRef('header-title');
    const filterWrapper = this.group.getElementByRef('checkbox-filter');
    const expandButton = this.group.getElementByRef('expand-button');
    const filterList = this.group.getElementByRef('filter-content-default');

    groupHeaderTitle.innerHTML = this.data.name;
    this.group.setAttribute('data-id', `filter-${this.data.id}`);
    expandButton.setAttribute('data-container', `filter-content-${this.data.id}`);
    filterList.setAttribute('ref', `filter-content-${this.data.id}`);

    if (this.data.filters.length > 10) {
      expandButton.setAttribute('data-scrollbar', 'true');
    }

    const filterGroups: Array<HTMLElement> = this.data.filters.map((filter: Object) => {
      const template: Node = filterWrapper.cloneNode(true);
      return new CheckboxFilterBuilder(template, filter, this.data).build();
    });

    filterWrapper.parentNode.prepend(...filterGroups);
    filterWrapper.remove();

    if (this.data.filters.length > 5) {
      expandButton.classList.remove('lg:hidden');

      Array.from(expandedFilters).forEach((filter) => {
        const ref = filter.getAttribute('ref');

        if (ref === filterList.getAttribute('ref')) {
          filterList.classList.add('expanded');

          if (this.data.filters.length > 10) {
            filterList.classList.add('overflow-y-scroll');
          }
          expandButton.innerHTML = expandButton.getAttribute('data-show-less');
        }
      });
    }

    return this.group;
  }
}
